/**
 * Copyright (c) 2025 Celestis AI
 *
 * WARNING: Unauthorized copying, modification, distribution, or use of this
 * software, via any medium, is strictly prohibited without explicit written
 * permission from Celestis AI.
 *
 * All rights reserved.
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
